import { Link as RouterLink } from 'react-router-dom'
import isURL from 'validator/lib/isURL'

import { Link } from '@tribeplatform/react-ui-kit/Link'

import { NavbarNavigationAction, NavbarNavigationItem } from '../constants'

export type NavbarNavigationProps = {
  navigationItems: NavbarNavigationItem[]
}

export const NavbarNavigation = ({
  navigationItems,
}: NavbarNavigationProps) => {
  const getLink = (
    label: string,
    link: string,
    external: boolean,
    newWindow: boolean,
  ) => {
    if (!link || !label) return null

    let cleanLink = link
    if (!cleanLink.startsWith('http') && !cleanLink.startsWith('/')) {
      cleanLink = `/${link}`
    }
    return (
      <Link
        as={external ? undefined : RouterLink}
        key={label}
        href={cleanLink}
        to={cleanLink}
        target={newWindow ? '_blank' : undefined}
        variant="neutral"
        className="truncate"
      >
        {label}
      </Link>
    )
  }

  const navigation = navigationItems
    ?.map(item => {
      const external =
        item.link && isURL(item.link, { require_valid_protocol: false })
      let cleanLink: string
      switch (item.action) {
        case NavbarNavigationAction.OPEN_LINK:
          cleanLink = item.link
          if (external && !cleanLink.startsWith('http')) {
            cleanLink = `https://${item.link}`
          }
          return getLink(item.label, cleanLink, external, item.openInNewWindow)
        default:
          return null
      }
    })
    .filter(item => item)

  return <>{navigation}</> || null
}
